import React, { useState, useEffect } from "react";
import { useLocalization } from "../../localization/LocalizationContext.js";
import allApi from "../../../../api/allApi";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function MeshSettings({ networkId }) {
  const { localizationStrings } = useLocalization();
  const [meshMode, setMeshMode] = useState("disable");
  const [isDirty, setIsDirty] = useState(false);
  const [isAutoDisabled, setIsAutoDisabled] = useState(false);
  const [isDisableDisabled, setIsDisableDisabled] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dedicatedBackhaul, setDedicatedBackhaul] = useState(0);

  // Fetch mesh settings on page load
  useEffect(() => {
    if (networkId) {
      getMeshSettings();
    }
  }, [networkId]);

  const getMeshSettings = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/wireless/getMeshSetting?networkId=${networkId}`
      );
      if (response && response.status === "200" && response.data) {
        setMeshMode(response.data.meshMode === 1 ? "auto" : "disable");
        setIsDirty(false);
        setErrorMessage("");
      } else {
        setErrorMessage(response?.message || "Failed to fetch mesh settings");
      }
    } catch (error) {
      console.error("API error:", error);
      setErrorMessage("Error fetching mesh settings");
    }
  };

  const inputSettings = async (e) => {
    e.preventDefault();
    try {
      const api = new allApi();
      const payload = {
        networkId,
        meshMode: meshMode === "auto" ? 1 : 2,
        dedicatedBackhaul,
      };
      const response = await api.postRequest(
        "api/wireless/meshSetting",
        "",
        payload
      );
      if (response && response.status === "200") {
        setShowSuccessPopup(true);
        setIsDirty(false);
        setErrorMessage("");
      } else {
        setErrorMessage(response?.message || "Failed to apply mesh settings");
      }
    } catch (error) {
      setErrorMessage("Error applying mesh settings");
    }
  };

  const handleCancelPopUp = () => {
    setShowSuccessPopup(false);
  };

  const handleCancel = () => {
    getMeshSettings();
    setIsDirty(false);
  };

  const handleMeshModeChange = (mode) => {
    setMeshMode(mode);
    setIsDirty(true);
  };

  return (
    <div className="tab-form w-scroll">
      <div className="row align-items-center mb-2">
        <div className="col-auto">
          <label>
            {localizationStrings?.meshMode || "Mesh Mode"}
            <i className="fa fa-question-circle ms-2" title="Mesh Mode Help" />
          </label>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4">
          <div className="switch-box">
            <strong>
              {meshMode === "auto"
                ? localizationStrings?.meshAuto || "Auto"
                : localizationStrings?.meshDisable || "Disable"}
              <span className="text-danger">*</span>
            </strong>
            <label className="ice-switch">
              <input
                type="checkbox"
                name="meshMode"
                checked={meshMode === "auto"}
                onChange={() => handleMeshModeChange(meshMode === "auto" ? "disable" : "auto")}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
      </div>
      {errorMessage && (
        <div className="alert alert-danger mt-3" role="alert">
          {errorMessage}
        </div>
      )}
      <div className="wifi-footer">
        <button
          type="button"
          className="btn btn-outline"
          onClick={handleCancel}
        >
          {localizationStrings?.cancel}
        </button>
        <button
          type="submit"
          className="text-btn primary-btn"
          onClick={inputSettings}
          disabled={!isDirty}
        >
          {localizationStrings?.save}
        </button>
      </div>
      <Modal
        show={showSuccessPopup}
        onHide={handleCancelPopUp}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert index-2000"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>
          {localizationStrings?.meshSuccessInfo ||
            "Mesh configuration applied successfully."}
        </p>
        <Button onClick={handleCancelPopUp}>{localizationStrings?.ok}</Button>
      </Modal>
    </div>
  );
}

export default MeshSettings;
